var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJupyterBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1290px",
    height: "1290px",
    viewBox: "0 0 1290 1290",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-305.000000, -209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(326.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    stroke: "#FFFFFF",
    strokeOpacity: 0.66686481
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 42,
    cx: 603,
    cy: 605,
    r: 390
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 42,
    cx: 625,
    cy: 585,
    r: 338
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 49,
    cx: 625,
    cy: 617,
    r: 294
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 42,
    cx: 600.5,
    cy: 654.5,
    r: 439.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 42,
    cx: 607.5,
    cy: 621.5,
    r: 476.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 42,
    cx: 630,
    cy: 583,
    r: 512
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 25,
    cx: 640,
    cy: 627,
    r: 549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624,1248 C968.625684,1248 1248,968.625684 1248,624 C1248,279.374316 968.625684,0 624,0 C279.374316,0 0,279.374316 0,624 C0,968.625684 279.374316,1248 624,1248 Z",
    id: "Oval",
    strokeWidth: 42
  })), /*#__PURE__*/React.createElement("g", {
    id: "jupyter",
    transform: "translate(559.000000, 538.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(105.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path7-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path0_fill-link",
    transform: "translate(0.497895, 0.029223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4722621,9.8791579 C20.5603547,11.9204684 20.0461105,13.9422221 18.9946263,15.6887211 C17.9431421,17.4351853 16.4016253,18.8278895 14.5651232,19.6906137 C12.7286211,20.5533726 10.6796337,20.8473505 8.67743684,20.5354137 C6.67524,20.2234421 4.80976737,19.3195895 3.31701411,17.93814 C1.82427474,16.5567253 0.771352421,14.7597884 0.291454958,12.7747168 C-0.188441463,10.7896453 -0.0737463156,8.70564316 0.621028737,6.78632842 C1.31580726,4.86697895 2.55944179,3.19862747 4.19461263,1.9922899 C5.82974526,0.785952316 7.78296316,0.095845548 9.80711368,0.0092826922 C12.5187758,-0.106682052 15.1651674,0.867688106 17.1649326,2.71833505 C19.1646979,4.56897158 20.3542611,7.14453474 20.4722621,9.8791579 Z",
    id: "path0_fill"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(4.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path8-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path1_fill-link",
    transform: "translate(0.892863, 0.005867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7222768,24.0657311 C35.7643283,24.0657311 12.2209641,14.362304 0,0 C4.5515083,12.8874827 13.0342939,24.0545991 24.2742072,31.9556879 C35.5143266,39.856608 48.9553541,44.100936 62.7373868,44.100936 C76.5194194,44.100936 89.9604469,39.856608 101.200566,31.9556879 C112.440342,24.0545991 120.923231,12.8874827 125.474774,0 C113.223658,14.362304 89.6805686,24.0657311 62.7222768,24.0657311 Z",
    id: "path1_fill"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(4.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path9-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path2_fill-link",
    transform: "translate(0.858522, 0.469200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7521534,20.0352724 C89.7104452,20.0352724 113.253878,29.7387332 125.474774,44.100936 C120.923231,31.2135545 112.440342,20.0464381 101.200566,12.1453493 C89.9604469,4.24426053 76.5194194,0 62.7373868,0 C48.9553541,0 35.5143266,4.24426053 24.2742072,12.1453493 C13.0342939,20.0464381 4.5515083,31.2135545 0,44.100936 C12.2509437,29.7684185 35.7942049,20.0352724 62.7521534,20.0352724 Z",
    id: "path2_fill"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(5.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path10-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3_fill-link",
    transform: "translate(0.047963, 0.399130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.997615,12.1523322 C26.11028,14.6650174 25.457425,17.1538617 24.121755,19.3037452 C22.786085,21.4536287 20.827625,23.1678991 18.494385,24.229513 C16.161145,25.291093 13.557985,25.6523009 11.01457,25.2673539 C8.47112,24.882407 6.10176,23.7686348 4.20644,22.0670478 C2.311148,20.3654609 0.975135001,18.152567 0.367559501,15.7085896 C-0.240014949,13.2645783 -0.0918263494,10.6993617 0.793362501,8.33772522 C1.6785545,5.97605478 3.2609395,3.92418 5.34016,2.44185104 C7.419405,0.959518696 9.90199,0.113403522 12.473615,0.0106264492 C15.913345,-0.126845973 19.268515,1.07404644 21.803635,3.35004913 C24.338755,5.62603826 25.84694,8.79144783 25.997615,12.1523322 Z",
    id: "path3_fill"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "path",
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path11-fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4_fill-link",
    transform: "translate(0.734542, 0.204000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.21738988,14.947386 C6.66011338,15.011272 5.11786488,14.63513 3.78586388,13.866662 C2.45385565,13.09816 1.3919974,11.971876 0.734677738,10.630304 C0.0773566307,9.288732 -0.145872027,7.792222 0.0932444057,6.330154 C0.332361199,4.86812 1.02307445,3.506284 2.07795696,2.4170022 C3.13283948,1.327734 4.50446238,0.560007199 6.01921975,0.211001279 C7.53397713,-0.138004981 9.12376613,-0.0526027606 10.5873705,0.456398999 C12.0509749,0.965399399 13.322611,1.875117 14.2412698,3.070404 C15.1599285,4.265708 15.6843551,5.692824 15.7481519,7.171144 C15.8335514,9.149638 15.0886178,11.079546 13.6768166,12.537364 C12.2650155,13.995216 10.3016218,14.861944 8.21738988,14.947386 Z",
    id: "path4_fill"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJupyterBackground);
export default __webpack_public_path__ + "static/media/jupyterBackground.70683be58adaaec160fc4f629e3c9247.svg";
export { ForwardRef as ReactComponent };